import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class QRCodeAPI extends ComponentAPI {
    getBackgroundColor() {
        return this.state.backgroundColor;
    }
    setBackgroundColor(backgroundColor) {
        this.setState({ backgroundColor });
    }
    getErrorLevel() {
        return this.state.errorLevel;
    }
    setErrorLevel(errorLevel) {
        this.setState({ errorLevel });
    }
    getForegroundColor() {
        return this.state.foregroundColor;
    }
    setForegroundColor(foregroundColor) {
        this.setState({ foregroundColor });
    }
    shouldIncludeMargin() {
        return this.state.includeMargin;
    }
    setIncludeMargin(includeMargin) {
        this.setState({ includeMargin });
    }
    getSize() {
        return this.state.size;
    }
    setSize(size) {
        this.setState({ size });
    }
    getValue() {
        return this.state.value;
    }
    setValue(value) {
        this.setState({ value });
    }
}
export { QRCodeAPI, };
//# sourceMappingURL=qrcode-api.js.map